// extracted by mini-css-extract-plugin
export default {"sub_menu_page":"SubMenuPageWrapper_sub_menu_page__xaCSL","sub_menu_body":"SubMenuPageWrapper_sub_menu_body__T341V"};